import { Injectable } from '@angular/core';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccOrderService, OrderActions } from '@order/data-access';
import { FileDownloadService } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class OrderInvoicePaymentEffect {
  downloadOrderInvoicePayment$: Observable<
    OrderActions.DownloadOrderInvoicePaymentSuccess | OrderActions.DownloadOrderInvoicePaymentError
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<OrderActions.DownloadOrderInvoicePayment>(OrderActions.DOWNLOAD_ORDER_INVOICE_PAYMENT),
      map((action) => action.payload),
      mergeMap(({ orderId, orderCode }) =>
        this.occOrderService.getOrderInvoicePayment(orderId).pipe(
          map((value) => {
            const url = URL.createObjectURL(value);
            this.fileDownloadService.download(url, `${orderCode}.pdf`);

            return new OrderActions.DownloadOrderInvoicePaymentSuccess({ orderId });
          }),
          catchError((error: unknown) => {
            this.snackbarFacade.setSnack({
              theme: SnackTheme.Yellow,
              title: 'Ошибка',
              text: 'Не удалось загрузить счёт',
            });

            return of(new OrderActions.DownloadOrderInvoicePaymentError({ orderId, error }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private occOrderService: OccOrderService,
    private snackbarFacade: SnackbarFacade,
    private fileDownloadService: FileDownloadService,
  ) {}
}
